import { Injectable } from "@angular/core";
import {GetServices, IsAttachService, IsSidebarToggled, SelectedService } from "./services.actions";
import { BaseState } from "../../base/state/base.state";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Service } from "../../../core/domain";


export class ServicesStateModel {
  services: Service[] | undefined;
  selectedService: Service | undefined;
  isEdited : boolean | undefined;
  isAttachService : boolean | undefined;
  newCreatedService : Service | undefined;
  IsSidebarToggled: boolean | undefined;
}

const defaults = {
  servicesGridHeader: undefined,
  services: undefined,
  selectedService: undefined,
  isEdited :undefined,
  newCreatedService : undefined,
  isAttachService: undefined,
  IsSidebarToggled: true,

};

@State<ServicesStateModel>({
  name: "services",
  defaults
})
@Injectable()
export class ServicesState extends BaseState {

  constructor() {
    super();
  }


  @Action(GetServices)
  getServices(ctx: StateContext<ServicesStateModel>, { payload }: GetServices) {
    ctx.setState({ ...ctx.getState(), services: payload });
  }

  @Action(SelectedService)
  selectedServices(ctx: StateContext<ServicesStateModel>, { payload }: SelectedService) {
    if (payload) {
      return ctx.setState({ ...ctx.getState(), selectedService: payload });
    } else {
      return ctx.setState({ ...ctx.getState(), selectedService: undefined });
    }
  }

  @Action(IsAttachService)
  isAttachService(ctx: StateContext<ServicesStateModel>, { payload }: IsAttachService) {
    ctx.setState({ ...ctx.getState(), isAttachService: payload });
  }

  @Action(IsSidebarToggled)
  IsSidebarToggled(
    ctx: StateContext<ServicesStateModel>,
    { payload }: IsSidebarToggled
  ) {
    ctx.setState({ ...ctx.getState(), IsSidebarToggled: payload });
  }


  @Selector()
  static Services(state: ServicesStateModel) {
    return state.services;
  }

  @Selector()
  static SelectedServices(state: ServicesStateModel) {
    return state.selectedService;
  }

  @Selector()
  static IsAttachService(state: ServicesStateModel) {
    return state.isAttachService;
  }

  @Selector()
  static IsSidebarToggled(state: ServicesStateModel) {
    return state?.IsSidebarToggled ?? true;
  }
}
